import React, { useEffect, useRef, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import "../../scss/card.css"
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { generateAxiosInstanceCommon } from '../../hooks/useAuthorizedReuestCommon';
import { generateAxiosInstanceCommonFileUpload } from '../../hooks/useAuthorizedRequestForFileUpload';
import { useNavigate } from 'react-router-dom';
import { CModal } from '@coreui/react';
import { getLink, handleQuestionUpdate, handleSelectAll, ImageModal, isErrorQuestion, Loader, SolutionModal, validateQuestionData } from '../../components/ModalsCommonFunctions';
import ViewImageAndText from '../../components/ViewImageAndText';

const InstituteUploadContentTextBook = () => {
    const authorizedAxiosCommon = generateAxiosInstanceCommon()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    let instituteMasterId = localStorage.getItem("instituteMasterId");
    const inputRef = useRef(null);

    const initialFormState = {
        instituteMasterId: instituteMasterId,
        instituteSyllabusStructureMasterId: '',
        instituteLessonMasterId: '',
        instituteTopicMasterId: '',
        instituteSubjectMasterId: '',
        instituteSubTopicMasterId: '',
        importFile: "",
        questionData: []
    }
    const [jsonPars, setJasonParse] = useState([])
    const [text, setText] = useState('')
    const [showPdfLinkdataType, setShowPdfLikDateType] = useState()
    const [showPdfLink, setShowPdfLink] = useState([])
    const [visible, setVisible] = useState(false)
    const [selectedGrade, setSelectedGrade] = useState()
    const [selectedDivision, setSelectedDivision] = useState()
    const [questionList, setQuestionList] = useState([])
    const [errorQuestions, setErrorQuestions] = useState({})
    const [modalImageSrc, setModalImageSrc] = useState('');
    const [visibleImage, setVisibleImage] = useState(false);
    const [modalData, setModalData] = useState("")
    const [visibleSolution, setVisibleSolution] = useState(false);

    const [syllabusList, setSyllabusList] = useState([])
    const [lessonList, setLessonList] = useState([])
    const [topicList, setTopicList] = useState([])
    const [subTopicViewtopicList, setSubTopicViewtopicList] = useState([])
    const [subtopicList, setSubtopicList] = useState([])
    const [subjectList, setSubjectList] = useState([])
    const [subtopicData, setSubtopicData] = useState(initialFormState)
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    //error
    const initialErrorState = {

    }

    const [error, setError] = useState(initialErrorState)

    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getSyllabusList();
    }, []);

    const onViewImage = (imgSrc) => {
        setModalImageSrc(imgSrc);
        setVisibleImage(true);
    };

    useEffect(() => {
        if (subtopicData.instituteSubjectMasterId !== '') {
            let apiUrl = `/get-institute-question-bank-import-log?instituteMasterId=${instituteMasterId}&`;

            if (subtopicData.instituteSyllabusStructureMasterId) {
                apiUrl += `syllabusStructureId=${subtopicData.instituteSyllabusStructureMasterId}&`;
            }

            if (subtopicData.instituteSubjectMasterId) {
                apiUrl += `instituteSubjectMasterId=${subtopicData.instituteSubjectMasterId}&`;
            }

            if (subtopicData.instituteLessonMasterId) {
                apiUrl += `instituteLessonMasterId=${subtopicData.instituteLessonMasterId}&`;
            }

            if (subtopicData.instituteTopicMasterId) {
                apiUrl += `instituteTopicMasterId=${subtopicData.instituteTopicMasterId}&`;
            }

            apiUrl = apiUrl.replace(/&$/, '');
            authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
                .then(response => {
                    setSubtopicList(response.data.data);
                })
                .catch(error => {
                    setSubtopicList(error?.response?.data.result);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    }, [subtopicData]);

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `/get-institute-syllabus-structure?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const handleSyllabusChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteLessonMasterId: '',
                instituteTopicMasterId: '',
                instituteSubTopicMasterId: '',
                instituteSubjectMasterId: ''
            }
        })
        const apiUrl = `get-institute-syllabus-structure-Wise-institute-subjects?id=${e.target.value}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setSubjectList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSubjectChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteLessonMasterId: '',
                instituteTopicMasterId: '',
                instituteSubTopicMasterId: ''
            }
        })

        const apiUrl = `/get-institute-subject-wise-institute-lesson?instituteMasterId=${instituteMasterId}&instituteSyllabusStructureMasterId=${subtopicData.instituteSyllabusStructureMasterId}&instituteSubjectMasterId=${e.target.value}`
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setLessonList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleLessonChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteTopicMasterId: '',
                instituteSubTopicMasterId: '',
            }
        })
        const apiUrl = `/get-institute-lesson-wise-institute-sub-topic?id=${e.target.value}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setTopicList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleTopicChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteSubTopicMasterId: ''
            }
        })
        const apiUrl = `/get-institute-sub-topic-master?instituteMasterId=${instituteMasterId}&instituteSyllabusStructureMasterId=${subtopicData.instituteSyllabusStructureMasterId}&instituteSubjectMasterId=${subtopicData.instituteSubjectMasterId}&instituteLessonMasterId=${subtopicData.instituteLessonMasterId}&instituteTopicMasterId=${e.target.value}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setSubTopicViewtopicList(response.data.result)
            })
            .catch(error => {
                console.error('Error fetching data:', error);
                setSubTopicViewtopicList([])
            });
    }

    const handleUploadLogo = async (e) => {
        const file = e.target.files[0];
        let fileExtension = file.name.split(".").pop()
        const body = new FormData();
        body.append("file", file);

        if (fileExtension == "xlsx" || fileExtension === "docx") {
            setLoading(true);

            try {
                const link = await getLink(e.target.name, body, setSubtopicData);
                if (!link) throw new Error('Link not generated');

                const endpoint = fileExtension === "docx"
                    ? "convert-question-bank-docx"
                    : "convert-question-bank-xlsx-v2";
                const payload = fileExtension === "docx"
                    ? { "wordFilePath": link }
                    : { "excelFilePath": link };

                const response = await authorizedAxiosCommon.post(endpoint, payload);
                setErrorQuestions(validateQuestionData(response.data.convertedData, true, setQuestionList));
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
                Swal.fire({ text: errorMsg });
            } finally {
                setLoading(false);
            }
        } else {
            Swal.fire({ text: "Only xlsx, docx file supported" });
        }
    }

    const validateForm = () => {
        const filterbookDataValid = Object.entries(subtopicData).every(([key, value]) => {
            if (key !== 'instituteTopicMasterId' && key !== 'instituteSubTopicMasterId') {
                if (typeof value === 'string') {
                    if (value === '') {
                        return false;
                    }
                }
            }
            return true;
        });

        const isQuestionDataNotEmpty = subtopicData.questionData.length > 0;

        if (subtopicData.importFile !== '' && subtopicData.importFile.length !== 0) {
            if (!isQuestionDataNotEmpty) {
                return false;
            }
        }

        return filterbookDataValid;
    };

    useEffect(() => {
        if (!Object.values(error).every(error => error === '')) {
            const newErrors = {};

            // Validate each field in filterbook
            for (const [key, value] of Object.entries(subtopicData)) {
                if (key !== 'instituteTopicMasterId' && key !== 'instituteSubTopicMasterId') {
                    if (typeof value === 'string' && value.trim() === '') {
                        newErrors[key] = 'This field is required.';
                    } else {
                        newErrors[key] = ''; // Clear error if field is valid
                    }
                }
            }

            const isQuestionDataNotEmpty = subtopicData.questionData.length > 0;

            if (subtopicData.importFile !== '' && subtopicData.importFile.length !== 0) {
                if (!isQuestionDataNotEmpty) {
                    newErrors['questionData'] = 'At least one question is required.';
                } else {
                    newErrors['questionData'] = ''; // Clear error if questionData is valid
                }
            }

            setError(newErrors); // Update error state with newErrors
        }
    }, [subtopicData]);

    const callQuestionBankSaveApi = (apiUrl, data) => {
        return authorizedAxiosInstitute && authorizedAxiosInstitute.post(apiUrl, data)
            .then(response => {
                setSubtopicData((prevData) => {
                    return {
                        ...prevData,
                        instituteLessonMasterId: '',
                        instituteTopicMasterId: '',
                        instituteSubTopicMasterId: '',
                        importFile: "",
                        questionData: []
                    }
                })

                setQuestionList([]);
                Swal.fire(
                    { text: response.data.message }
                );
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            });
    }

    // const addLesson = () => {
    //     if (validateForm()) {
    //         setLoading(true);
    //         let data = { ...subtopicData };
    //         const fileExtension = subtopicData.importFile.split('.').pop().toLowerCase();

    //         delete data.importFile;
    //         const questionIds = validateQuestionData(subtopicData.questionData, false);
    //         if (fileExtension === "docx") {
    //             const apiUrl = '/import-question-bank-docx';

    //             if (questionIds.errorCount > 0) {
    //                 const matchedQuestionIndices = questionIds.errorquestionIds.map(id => {
    //                     const index = questionList.findIndex(question => question.no === id);
    //                     return index !== -1 ? (index + 1).toString() : null;
    //                 }).filter(index => index !== null).join(', ');

    //                 const message = `Errors found in questions at indices: ${matchedQuestionIndices}`;

    //                 Swal.fire({
    //                     text: message
    //                 });
    //                 return;
    //             }

    //             callQuestionBankSaveApi(apiUrl, data);
    //         } else if (fileExtension === "xlsx") {
    //             const apiUrl = `/import-question-bank-xlsx`;

    //             if (questionIds.errorCount > 0) {
    //                 const matchedQuestionIndices = questionIds.errorquestionIds.map(id => {
    //                     const index = questionList.findIndex(question => question.no === id);
    //                     return index !== -1 ? (index + 1).toString() : null;
    //                 }).filter(index => index !== null).join(', ');

    //                 const message = `Errors found in questions at indices: ${matchedQuestionIndices}`;

    //                 Swal.fire({
    //                     text: message
    //                 });
    //                 return;
    //             }

    //             callQuestionBankSaveApi(apiUrl, data);
    //         }
    //     } else {
    //         const newErrors = {};

    //         // Validate each field in filterbook and update errors
    //         for (const [key, value] of Object.entries(subtopicData)) {
    //             if (key !== 'instituteTopicMasterId' && key !== 'instituteSubTopicMasterId') {
    //                 if (typeof value === 'string' && value.trim() === '') {
    //                     newErrors[key] = 'This field is required.';
    //                 } else {
    //                     newErrors[key] = ''; // Clear error if field is valid
    //                 }
    //             }
    //         }

    //         const isQuestionDataNotEmpty = subtopicData.questionData.length > 0;

    //         if (subtopicData.importFile !== '' && !isQuestionDataNotEmpty) {
    //             newErrors['questionData'] = 'At least one question is required.';
    //         } else {
    //             newErrors['questionData'] = ''; // Clear error if questionData is valid
    //         }

    //         setError(newErrors); // Update error state with newErrors
    //     }
    // }

    const addLesson = () => {
        if (!validateForm()) {
            handleFormErrors();
            return;
        }
    
        setLoading(true);
        let data = { ...subtopicData };
        const fileExtension = subtopicData.importFile.split('.').pop().toLowerCase();
        delete data.importFile;
    
        const questionIds = validateQuestionData(subtopicData.questionData, false);
        if (questionIds.errorCount > 0) {
            handleQuestionErrors(questionIds.errorquestionIds);
            setLoading(false);
            return;
        }
    
        const apiUrl = fileExtension === "docx"
            ? '/import-question-bank-docx'
            : '/import-question-bank-xlsx';
    
        callQuestionBankSaveApi(apiUrl, data)
            .finally(() => {
                setLoading(false);
            });
    };

    const handleFormErrors = () => {
        const newErrors = {};
    
        for (const [key, value] of Object.entries(subtopicData)) {
            if (key !== 'instituteTopicMasterId' && key !== 'instituteSubTopicMasterId') {
                newErrors[key] = typeof value === 'string' && value.trim() === '' ? 'This field is required.' : '';
            }
        }
    
        if (subtopicData.importFile !== '' && subtopicData.questionData.length === 0) {
            newErrors['questionData'] = 'At least one question is required.';
        } else {
            newErrors['questionData'] = '';
        }
    
        setError(newErrors);
    };

    const handleQuestionErrors = (errorQuestionIds) => {
        const matchedQuestionIndices = errorQuestionIds
            .map(id => {
                const index = questionList.findIndex(question => question.no === id);
                return index !== -1 ? (index + 1).toString() : null;
            })
            .filter(index => index !== null)
            .join(', ');
    
        const message = `Errors found in questions at indices: ${matchedQuestionIndices}`;
    
        Swal.fire({ text: message });
    };

    useEffect(() => {
        if (showPdfLink !== null) {
            if (showPdfLink.indexOf('[') >= 0) {
                setShowPdfLikDateType("array")
                setJasonParse(JSON.parse(showPdfLink))
            }
            else {
                setShowPdfLikDateType("string")
                setText(showPdfLink)
            }
        }
        else {
            setShowPdfLikDateType("string")
            setText(showPdfLink)
        }
    }, [showPdfLink])

    const getFileName = (path) => {
        let i = path.length - 1;
        let name = "";
        while (i >= 0 && path[i] !== "/") {
            name = path[i] + name;
            i--;
        }

        return name;
    }

    const handleInputReset = () => {
        setSubtopicData(initialFormState);
        setSubtopicList([]);
        inputRef.current.value = '';
        setError(initialErrorState);
    }


    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/institute-dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Upload Text Book Question Bank</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa fa-eye"></i> UPLOAD TEXT BOOK QUESTION BANK</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Syllabus Structure :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='instituteSyllabusStructureMasterId' onChange={handleSyllabusChange} value={subtopicData.instituteSyllabusStructureMasterId}>
                                                        <option selected value={''} disabled>Select Syllabus</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus?.instituteSyllabusStructureName}</option>
                                                            })
                                                        }
                                                    </select>

                                                    {error.instituteSyllabusStructureMasterId && <p style={{ color: 'red' }}>{error.instituteSyllabusStructureMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='instituteSubjectMasterId' onChange={handleSubjectChange} value={subtopicData.instituteSubjectMasterId}>
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {
                                                            subjectList?.map((syllabus) => {
                                                                return <option value={syllabus.instituteSubjectMasterDetails.id}>{syllabus.instituteSubjectMasterDetails.subjectName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteSubjectMasterId && <p style={{ color: 'red' }}>{error.instituteSubjectMasterId}</p>}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='instituteLessonMasterId' onChange={handleLessonChange} value={subtopicData.instituteLessonMasterId}>
                                                        <option selected value={''} disabled>Select Lesson</option>
                                                        {
                                                            lessonList?.map((lesson) => {
                                                                return <option value={lesson.id}>{lesson.instituteLessonName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteLessonMasterId && <p style={{ color: 'red' }}>{error.instituteLessonMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Topic :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='instituteTopicMasterId' onChange={handleTopicChange} value={subtopicData.instituteTopicMasterId}>
                                                        <option selected value={''} disabled>Select Topic</option>
                                                        {
                                                            topicList?.map((topic) => {
                                                                return <option value={topic.id}>{topic.instituteTopicName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Sub Topic :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='instituteSubTopicMasterId' onChange={handleInputChange} value={subtopicData.instituteSubTopicMasterId}>
                                                        <option selected value={''} disabled>Select Sub Topic</option>
                                                        {
                                                            subTopicViewtopicList?.map((topic) => {
                                                                return <option value={topic.id}>{topic.instituteSubTopicName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Upload Text Book Question Bank :<span style={{ color: "red" }}>only xlsx & docx file supported</span></label>
                                                    {/* <label style={{ color: "red" }} > max 30 Mb file supported</label> */}
                                                    <input required type="file" className="form-control" name="importFile" onChange={handleUploadLogo} ref={inputRef} />

                                                    <a download href='https://api.examninja.co.in/files/question-bank-import-ex.xlsx'>Sample xlsx file</a>&nbsp;
                                                    <a download href='https://api.examninja.co.in/files/SampleDoc.docx'>Sample docx file</a>
                                                    {error.importFile && <p style={{ color: 'red' }}>{error.importFile}</p>}
                                                </div>

                                            </div>

                                            <div>
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={handleInputReset}>Reset</button>
                                                    <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={addLesson}>Save</button>
                                                </div>

                                                <CModal
                                                    visible={visible}
                                                    onClose={() => setVisible(false)}
                                                    aria-labelledby="LiveDemoExampleLabel"
                                                >

                                                    <div className="book book-modal">
                                                        <div className='table-header-like'>  {selectedGrade} - {selectedDivision}</div>
                                                        <div style={{ overflowY: "scroll", }} className='page' >
                                                            <div>
                                                                {
                                                                    showPdfLinkdataType == "array" ?
                                                                        // console.log(jsonPars)

                                                                        <table class="table">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th scope="col" className='sl_no'>Sr. No.</th>
                                                                                    <th scope="col">Name </th>
                                                                                    <th scope="col">Purpose </th>

                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {
                                                                                    jsonPars.map((lesson, index) => {
                                                                                        return (
                                                                                            <tr>
                                                                                                <th scope="row" className='sl_no'>{index + 1}</th>
                                                                                                <td>{lesson.record[2]}</td>
                                                                                                <td>{lesson.purpose}</td>
                                                                                            </tr>
                                                                                        )
                                                                                    })
                                                                                }

                                                                            </tbody>
                                                                        </table>
                                                                        :
                                                                        <div className='no-error-class'>{text ? text : "No error found"}</div>
                                                                }
                                                            </div>


                                                        </div>
                                                        <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisible(false)}>
                                                            Close
                                                        </button>
                                                    </div>
                                                </CModal>

                                                {visibleSolution && <SolutionModal visibleSolution={visibleSolution} setVisibleSolution={setVisibleSolution} modalData={modalData} />}

                                                {visibleImage && <ImageModal visibleImage={visibleImage} setVisibleImage={setVisibleImage} modalImageSrc={modalImageSrc} />}

                                                {/* {questionList.length === 0 && <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col">Uploaded Files </th>
                                                                        <th scope="col">Total Question Count</th>
                                                                        <th scope="col">Imported Question Count</th>
                                                                        <th scope="col">Syllabus Structure</th>
                                                                        <th scope="col">Subject</th>
                                                                        <th scope="col">Lesson</th>
                                                                        <th scope="col">Topic</th>
                                                                        <th scope="col">Sub Topic</th>
                                                                        <th scope="col">Note</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        subtopicList?.length > 0 ?
                                                                            subtopicList.map((lesson, index) => {
                                                                                console.log("lesson = ", lesson);
                                                                                return (
                                                                                    <tr key={index} className={lesson.importStatus == "IMPORTED" ? 'greenTable' : lesson.importStatus == "FAILED" ? "redTable" : lesson.importStatus == "NOT STARTED" ? "yellowTable" : "yellowTable"}>
                                                                                        <td>{getFileName(lesson?.localFilePath)}<a href={lesson.localFilePath} download style={{ textDecoration: "none" }}><i class="fa-solid fa-download"></i></a></td>
                                                                                        <td>{lesson?.importedQuestionCount}</td>
                                                                                        <td>{lesson?.importedQuestionCount}</td>
                                                                                        <td>{lesson?.instituteSyllabusStructureMasterDetails?.instituteSyllabusStructureName}</td>
                                                                                        <td>{lesson?.instituteSubjectMasterDetails?.subjectName}</td>
                                                                                        <td>{lesson?.instituteLessonMasterDetails?.instituteLessonName}</td>
                                                                                        <td>{lesson?.instituteTopicMasterDetails?.instituteTopicName}</td>
                                                                                        <td>{lesson?.instituteSubTopicMasterDetails?.instituteSubTopicName}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-primary view_icon" type="button" onClick={() => {

                                                                                                setShowPdfLink(lesson.note)
                                                                                                setVisible(true)
                                                                                                setSelectedGrade(lesson?.instituteSyllabusStructureMasterDetails?.instituteSyllabusStructureName)
                                                                                                setSelectedDivision(lesson?.instituteSubjectMasterDetails?.subjectName)
                                                                                            }}><i class="fa fa-eye" ></i> Error</button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Student Available</th>

                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>} */}

                                                {questionList.length !== 0 && <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-pane p-3 active prefilter" role="tabpanel" id="prefilter-1000">
                                                        {/* {questions.length > 0 && <ErrorMessage errors={errors} field="question_ids" />} */}
                                                        <div>
                                                            {errorQuestions.errorCount > 0 && (
                                                                <div className="alert alert-danger" role="alert">
                                                                    {errorQuestions.errorCount === 1 ?
                                                                        `There is ${errorQuestions.errorCount} invalid or empty question` :
                                                                        `There are ${errorQuestions.errorCount} invalid or empty questions`
                                                                    }
                                                                </div>
                                                            )}
                                                        </div>
                                                        {error.questionData && <p style={{ color: 'red' }}>{error.questionData}</p>}
                                                        <table class="table">
                                                            <thead>
                                                                <tr>
                                                                    {questionList?.length > 0 && <th>
                                                                        <input
                                                                            type='checkbox'
                                                                            checked={subtopicData.questionData.length === questionList.length}
                                                                            onClick={() => handleSelectAll(questionList, subtopicData, setSubtopicData)}
                                                                        /> All
                                                                    </th>}
                                                                    <th scope="col" className='sl_no'>Sr. No.</th>
                                                                    <th scope='col'>Q_Level</th>
                                                                    <th scope='col'>Q_Type</th>
                                                                    <th scope='col'>Question</th>
                                                                    <th scope="col">Option_a</th>
                                                                    <th scope="col">Option_b </th>
                                                                    <th scope="col">Option_c</th>
                                                                    <th scope="col">Option_d</th>
                                                                    <th scope='col'>Answer</th>
                                                                    <th scope='col'>Solution</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    questionList?.length > 0 ?
                                                                        questionList?.map((question, index) => {
                                                                            const rowClass = isErrorQuestion(errorQuestions, question) ? 'error-row' : '';

                                                                            return (
                                                                                <tr key={index} className={rowClass}>
                                                                                    <td><input type='checkbox' checked={subtopicData.questionData.some(q => q.no === question.no)} onChange={() => handleQuestionUpdate(question, subtopicData, setSubtopicData)} /></td>
                                                                                    <th scope="row" className='sl_no'>{index + 1}</th>
                                                                                    <td>E</td>
                                                                                    <td>S</td>
                                                                                    {/* <td><ViewImageAndText inputString={question.question} onViewImage={onViewImage} /></td>
                                                                                    <td><ViewImageAndText inputString={question.options['a)']} onViewImage={onViewImage} /></td>
                                                                                    <td><ViewImageAndText inputString={question.options['b)']} onViewImage={onViewImage} /></td>
                                                                                    <td><ViewImageAndText inputString={question.options['c)']} onViewImage={onViewImage} /></td>
                                                                                    <td><ViewImageAndText inputString={question.options['d)']} onViewImage={onViewImage} /></td> */}
                                                                                    <td><div dangerouslySetInnerHTML={{ __html: question.question }} /></td>
                                                                                    <td><div dangerouslySetInnerHTML={{ __html: question.options['a)'] }} /></td>
                                                                                    <td><div dangerouslySetInnerHTML={{ __html: question.options['b)'] }} /></td>
                                                                                    <td><div dangerouslySetInnerHTML={{ __html: question.options['c)'] }} /></td>
                                                                                    <td><div dangerouslySetInnerHTML={{ __html: question.options['d)'] }} /></td>
                                                                                    <td>{question.answer}</td>
                                                                                    <td>
                                                                                        <button className="btn btn-primary view_icon mt-1" type="button" onClick={() => {
                                                                                            setVisibleSolution(!visibleSolution)
                                                                                            setModalData(question.solution)
                                                                                        }}><i class="fa fa-eye" ></i></button>
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        })
                                                                        :
                                                                        (<tr>
                                                                            <th colspan={"100%"} style={{ textAlign: 'center' }}>No Questions Available</th>
                                                                        </tr>)
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <Footer />
        </>
    )
};

export default InstituteUploadContentTextBook;


